/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2e30abbd"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "bg"
};
var _hoisted_3 = {
  style: {
    "text-align": "center",
    "margin-top": "20px"
  }
};
var _hoisted_4 = {
  key: 1,
  class: "fixedInfo"
};
var _hoisted_5 = {
  class: "main"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "添加点检记录", -1);
});
var _hoisted_7 = {
  style: {
    "padding": "20px 10px"
  }
};
var _hoisted_8 = {
  class: "row"
};
var _hoisted_9 = {
  class: "row"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "点检内容：", -1);
});
var _hoisted_11 = {
  class: "row"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "点检结果：", -1);
});
var _hoisted_13 = {
  class: "row"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "点检人员：", -1);
});
var _hoisted_15 = {
  class: "row"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "备注信息：", -1);
});
import { Step, Steps } from 'vant';
import { showToast } from 'vant';
import hyRequest from '@/service';
export default {
  __name: 'PointRepair',
  setup: function setup(__props) {
    var device_id = useRoute().query.device_id;
    var device_name = useRoute().query.deviceName;
    var List = ref([]);
    function getData() {
      hyRequest.post({
        url: '/repair/devicePointRecordByFactoryDevice',
        data: {
          device_id: device_id,
          pageNumber: 1,
          pageSize: 20000
        }
      }).then(function (data) {
        data.list.forEach(function (item) {
          List.value.push(_objectSpread(_objectSpread({}, item), JSON.parse(item.remark)));
        });
        console.log(List.value);
      });
    }
    getData();
    var show = ref(false);
    var saveType = ref('insert');
    var form = reactive({
      id: '',
      device_id: device_id,
      device_name: device_name,
      a: '',
      b: '',
      c: ''
    });

    // function edit(item) {
    //   saveType.value = 'update';
    //   form.id = item.id;
    //   form.info = item.info;
    //   form.remark = item.remark;
    //   defaultDay.value = dayjs(item.next_time).toDate();
    //   show.value = true;
    // }

    // function remove(id) {
    //   console.log(id);
    //   hyRequest
    //     .post({
    //       url: '/repair/maintainDel',
    //       data: {
    //         id
    //       }
    //     })
    //     .then(() => {
    //       showToast('删除成功！');
    //       getData();
    //     });
    // }

    function openDialog() {
      form.next_time = '';
      form.info = '';
      form.remark = '';
      show.value = true;
      saveType.value = 'insert';
    }

    // const defaultDay = ref(dayjs().toDate());
    var columns = reactive([]);
    var chooseColumns = ref('');
    var showPicker = ref(false);
    function getColums() {
      hyRequest.post({
        url: '/repair/deviceRepairItem',
        data: {
          device_id: device_id
        }
      }).then(function (data) {
        columns.push.apply(columns, _toConsumableArray(data.list));
      });
    }
    getColums();
    function onConfirm(e) {
      console.log(e);
      form.check_result_id = e.id;
      chooseColumns.value = e.check_point_result;
      showPicker.value = false;
    }
    function cancel() {
      show.value = false;
    }
    function saveData() {
      var url = '';
      if (saveType.value == 'insert') {
        url = '/repair/devicePointRecordAdd';
      } else {
        url = '/repair/deviceRepairItemModfiy';
      }
      var tmp = {
        remark: {
          a: form.a,
          b: form.b,
          c: form.c
        }
      };
      hyRequest.post({
        url: url,
        data: {
          device_id: form.device_id,
          check_name: form.device_name,
          check_result_id: 1,
          remark: JSON.stringify(tmp)
        }
      }).then(function () {
        show.value = false;
        showToast('保存成功');
        getData();
      });
    }
    if (useRoute().query.add == 1) {
      openDialog();
    }
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", null, [_unref(show) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "wrapper",
        onClick: _cache[3] || (_cache[3] = _withModifiers(function () {}, ["stop"]))
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_cell_group, {
        border: false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: _unref(form).a,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _unref(form).a = $event;
            }),
            label: "点位信息",
            "label-width": "auto",
            colon: "",
            type: "textarea",
            autocomplete: "off",
            placeholder: "请输入点位信息"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        border: false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: _unref(form).b,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _unref(form).b = $event;
            }),
            label: "点检内容",
            "label-width": "auto",
            colon: "",
            type: "textarea",
            autocomplete: "off",
            placeholder: "请输入点检内容"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        border: false
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: _unref(form).c,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _unref(form).c = $event;
            }),
            label: "备注信息",
            autocomplete: "off",
            "label-width": "auto",
            colon: "",
            type: "textarea",
            placeholder: "请输入备注信息"
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
        type: "warning",
        size: "small",
        onClick: cancel,
        style: {
          "width": "80px"
        }
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("取消")];
        }),
        _: 1
      }), _createVNode(_component_van_button, {
        type: "primary",
        size: "small",
        style: {
          "margin-left": "40px",
          "width": "80px"
        },
        onClick: saveData
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("保存")];
        }),
        _: 1
      })])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "btn",
        onClick: openDialog
      }, [_createVNode(_component_van_icon, {
        name: "add-o",
        size: "15"
      }), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(Steps), {
        direction: "vertical",
        "active-color": "#969799",
        "inactive-icon": "passed",
        "active-icon": "passed"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(List), function (item, index) {
            return _openBlock(), _createBlock(_unref(Step), {
              key: index
            }, {
              "inactive-icon": _withCtx(function () {
                return [_createVNode(_component_van_icon, {
                  name: "shield-o",
                  size: "20",
                  color: "#4485f3"
                })];
              }),
              "active-icon": _withCtx(function () {
                return [_createVNode(_component_van_icon, {
                  name: "shield-o",
                  size: "20",
                  color: "#4485f3"
                })];
              }),
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_8, [_createElementVNode("b", null, _toDisplayString(item.create_time), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(item.remark.a), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(item.remark.b), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", null, _toDisplayString(item.check_persion), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, _toDisplayString(item.remark.c), 1)])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })])])])), _createVNode(_component_van_popup, {
        show: _unref(showPicker),
        "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
          return _isRef(showPicker) ? showPicker.value = $event : null;
        }),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_picker, {
            columns: _unref(columns),
            "columns-field-names": {
              text: 'check_point_result',
              value: 'id'
            },
            onCancel: _cache[4] || (_cache[4] = function ($event) {
              return showPicker.value = false;
            }),
            onConfirm: onConfirm
          }, null, 8, ["columns"])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
};